export const regionIds = {
    MoscowRegionId: 4,
    UdmurtiaRegionId: 27,
};
